// #region imports

// --- Angular
import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ContentChild,
  ElementRef,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef
} from '@angular/core';

// --- RxJs
import { Subject, fromEvent, Subscription, BehaviorSubject } from 'rxjs';
import { filter, take, switchMapTo } from 'rxjs/operators';

// --- HS Code
import { ViewModeDirective, EditModeDirective } from '..';

// #endregion

@Component({
  selector: 'hs-edit-in-place',
  templateUrl: './edit-in-place.component.html',
  styleUrls: ['./edit-in-place.component.scss']
})
export class EditInPlaceComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isInEditMode: boolean;
  @Output() update = new EventEmitter();
  @Output() modeChanged = new EventEmitter<boolean>();
  @ContentChild(ViewModeDirective, { static: true }) viewModeTpl: ViewModeDirective;
  @ContentChild(EditModeDirective, { static: true }) editModeTpl: EditModeDirective;

  private _clickSubscription: Subscription;
  private _editModeSubscription: Subscription;

  private _mode: 'view' | 'edit' = 'view';
  private _editMode$ = new Subject();
  editMode$ = this._editMode$.asObservable();

  constructor(private host: ElementRef) {
  }

  currentView: TemplateRef<any>;

  // get currentView() {
  //   return this._mode === 'view'
  //     ? this.viewModeTpl.tplRef
  //     : this.editModeTpl.tplRef;
  // }

  ngOnInit() {
    this.currentView = this.viewModeTpl.tplRef;
    this.viewModeHandler();
    this.editModeHandler();
  }

  ngOnDestroy(): void {
    if (this._clickSubscription) {
      this._clickSubscription.unsubscribe();
      this._clickSubscription = null;
    }

    if (this._editModeSubscription) {
      this._editModeSubscription.unsubscribe();
      this._editModeSubscription = null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isInEditMode.currentValue && this._mode !== 'edit') {
      this._mode = 'edit';
      this.currentView = this.editModeTpl.tplRef;
      this._editMode$.next(true);
    } else if (!changes.isInEditMode.currentValue && this._mode !== 'view') {
      this.toViewMode();
    }
  }

  public toViewMode(): void {
    this.update.emit();
    this._mode = 'view';
    this.currentView = this.viewModeTpl.tplRef;
    this.modeChanged.emit(false);
  }

  private get element() {
    return this.host.nativeElement;
  }

  private viewModeHandler() {
    this._clickSubscription = fromEvent(this.element, 'dblclick').subscribe(
      () => {
        this._mode = 'edit';
        this.currentView = this.editModeTpl.tplRef;
        this._editMode$.next(true);
        this.modeChanged.emit(true);
      }
    );
  }

  private editModeHandler() {
    const clickOutside$ = fromEvent(document, 'click').pipe(
      filter(({ target }) => this.element.contains(target) === false),
      take(1)
    );

    this._editModeSubscription = this.editMode$
      .pipe(
        switchMapTo(clickOutside$)
      )
      .subscribe(event => {
        this._mode = 'view';
        this.currentView = this.viewModeTpl.tplRef;
        this.update.emit();
        this.modeChanged.emit(false);
      });
  }
}
